import { createStore } from 'vuex'
import VuexPersistence from "vuex-persist";
import {auth, storage} from '@/firebase'
import { ref, list, getDownloadURL } from 'firebase/storage';
import {BlogActions, BlogGetters, BlogMutations, BlogState} from './blogsState'
import {CompaniesActions, CompaniesGetters, CompaniesMutations, CompaniesState} from './companiesState'

const defaultState = {
  ...BlogState,
  ...CompaniesState,
  topics: [
    'Investment',
    'Fed. Tax Credit',
    'Environmental Incentives',
    'Warranty/Maintenance',
    "Net-metering",
    'Benefits',
    'Efficiency/Lifespan',
    'Eligibility',
    'Components'
  ],

  images: [],
  lazyMeta: {
    images: {
      nextPageToken: null,
    },
    adminBlogs: {
      nextPageToken: null,
    },
    allBlogs: {
      lastVisible: null,
      done: false,
      loading: false,
    },
    contacts: {
      lastVisible: null,
      done: false,
      loading: false,
    },
    blogTopics: {}
  },
  cachedState: {
    blogTopics: {},
    allBlogs: []
  },
  dumpTime: new Date(),
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    restoreState: (key) => {
      let data = JSON.parse(localStorage.getItem(key) || "{}")  ;

      if (!data.dumpTime || new Date(data.dumpTime) < new Date() - 1000 * 60 * 60 * 24 * 7 ) {
        defaultState.dumpTime = new Date()
        return defaultState
      }

      data = Object.assign(defaultState, data)
      return data
    },
    saveState: (key, state) => {
      state.updatedAt = new Date()
      const data = JSON.stringify(state);
      return localStorage.setItem(key, data)
    },
});



export default createStore({
  state: defaultState,
  getters: {
    ...BlogGetters,
    ...CompaniesGetters,
  },
  mutations: {
    ...BlogMutations,
    ...CompaniesMutations,
    setState(state, payload){ // payload is {keyToReplace: value}
      // only use this to replace entire top level key
      state = Object.assign(state, payload)
      // console.log(state)
    },
    clearState(state){
      state = Object.assign(state, defaultState)
    },
    processListImageResult(state, response){
      state.lazyMeta.images.nextPageToken = response.nextPageToken
      response.items.forEach(element => {
        getDownloadURL(element)
          .then((url) => {
            state.images.push(url)
          })
          .catch((error) => {
            console.log("could not get download url " + error, 'red')
          })
      });
    },
    addImage(state, url){
      state.images.push(url)
    }
  },
  actions: {
    ...BlogActions,
    loadImages({commit, state}){
      list(ref(storage,'/images'), {maxResults: 30, pageToken: state.lazyMeta.images.nextPageToken})
        .then((res) => {
          commit('processListImageResult', res)
        })
        .catch((error) => {
          console.log("could not load images " + error, 'red')
        })
    },
    ...CompaniesActions,
  },
  modules: {
  },
  plugins: [vuexLocal.plugin],
})
